import { Utils } from '../../../../shared/utils';

export class SubventionAmortisationModel {
  accountActivity: string;
  year: number;
  month: string;
  amount: number;
  total: number;
  name: string;

  constructor(){
  }

}

export interface SubventionAmortisationSummary {
  name: string;
  total: number;
  accumulated: number;
  remaining: number;
}

export function summarizeAmortisation(rows: SubventionAmortisationModel[]): SubventionAmortisationSummary {
  if (!rows || !rows.length) {
    return { name: '', total: 0, accumulated: 0, remaining: 0 };
  }
  const total = Utils.GetValueWithDecimals(rows[0].total);
  const accumulated = Utils.GetValueWithDecimals(rows.reduce((sum, r) => sum + (r.amount || 0), 0));
  return {
    name: rows[0].name,
    total,
    accumulated,
    remaining: Utils.GetValueWithDecimals(total - accumulated),
  };
}
